export default "__VITE_ASSET__CvC747hl__"